import gql from 'graphql-tag';

const STOCKTAKE_DETAIL_FRAGMENT = gql`
	fragment stocktakeDetail on Stocktake {
		id
		created
		date
		status
		percentageDifference
		valueOfDifference
		valueNotAccurate
		description
		warehouse {
			id
			name
		}
		user {
			id
			firstname
			lastname
			destroyed
		}
		items {
			id
			countedExpiryBatches
			warehouseProduct {
				id
				pickOrder
				quantity
				expiryBatchPreview
				expiryBatchSummary
				expiryBatches {
					id
					quantityOnHand
					expiryDate
					bestBeforeDate
					supplierBatchCode
					status
					receivedAt
					expiryDateSource
				}
				product {
					id
					name
					cost
					imageUrl
					destroyed
					measurementUnit
					caseSize
					shipperSize
					palletSize
					barcodes
					forceQuantityInUnits
					overridingWarehouseProduct {
						id
						name
					}
				}
			}
			preStocktakeQuantity
			quantity
		}
	}
`;

export const GET_STOCKTAKE = gql`
	query($id: String) {
		getStocktake (id: $id) {
			...stocktakeDetail
		}
	}
	${STOCKTAKE_DETAIL_FRAGMENT}
`;

export const SUBSCRIBE_TO_STOCKTAKE = gql`
	subscription ($input: StocktakeSubscriptionInput!) {
		StocktakeSubscription(input: $input) {
			stocktake {
				...stocktakeDetail
			}
			destroyedStocktakeId
		}
	}
	${STOCKTAKE_DETAIL_FRAGMENT}
`;
